import { useEditor } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';
import style from './index.module.scss';

function Logo({ styleAlt }) {
    const { isEditing } = useEditor();

    return (
        <>
            {isEditing ? (
                <div>
                    <p>Logo principal :</p>
                    <EditableImg smartProp={'logoMain'} className={style.logo} />
                    <p>Logo alternatif :</p>
                    <EditableImg smartProp={'logoAlt'} className={style.logo} />
                </div>
            ) : (
                <a href="/" className={style.link}>
                    <EditableImg smartProp={styleAlt ? 'logoAlt' : 'logoMain'} className={style.logo} />
                </a>
            )}
        </>
    );
}

export default Logo;
